import { Listener, Stream, Unsubscribe } from './stream';

export class StateStream<T> extends Stream<T> {
  private _state: T;
  private _prevState: T | null = null;

  constructor(initialState: T) {
    super();
    this._state = initialState;
  }

  public onWithState(listener: Listener<T>): Unsubscribe {
    const unsubscribe = this.on(listener);
    listener(this._state);
    return unsubscribe;
  }

  public onPrevState(listener: (state: T, prevState: T | null) => void): Unsubscribe {
    return this.on((state: T) => {
      listener(state, this._prevState);
    });
  }

  public override emit(data: T): void {
    if (this._state !== data) {
      this._prevState = this._state;
      this._state = data;
      super.emit(data);
    }
  }

  public get state(): T {
    return this._state;
  }

  public get prevState(): T | null {
    return this._prevState;
  }
}
